import common from "./common/zh_cn.yml";
import form from "./form/zh_cn.yml";
import adminUser from "./adminUser/zh_cn.yml";
import hotel from "./hotel/zh_cn.yml";
import hotelRoom from "./hotelRoom/zh_cn.yml";
import hotelPlan from "./hotelPlan/zh_cn.yml";
import hotelCancelPolicy from "./hotelCancelPolicy/zh_cn.yml";
import hotelChildrenSetting from "./hotelChildrenSetting/zh_cn.yml";
import hotelQuestion from "./hotelQuestion/zh_cn.yml";
import hotelOption from "./hotelOption/zh_cn.yml";
import hotelFilter from "./hotelFilter/zh_cn.yml";
import hotelMail from "./hotelMail/zh_cn.yml";
import hotelWaitingList from "./hotelWaitingList/zh_cn.yml";
import hotelInventory from "./hotelInventory/zh_cn.yml";
import hotelPrice from "./hotelPrice/zh_cn.yml";
import hotelScript from "./hotelScript/zh_cn.yml";
import hotelCheckIn from "./hotelCheckIn/zh_cn.yml";
import hotelCheckInQuestion from "./hotelCheckInQuestion/zh_cn.yml";
import hotelPushMessageGroup from "./hotelPushMessageGroup/zh_cn.yml";
import hotelCalendar from "./hotelCalendar/zh_cn.yml";
import booking from "./booking/zh_cn.yml";
import company from "./company/zh_cn.yml";
import companyInvoice from "./companyInvoice/zh_cn.yml";
import companyPayment from "./companyPayment/zh_cn.yml";
import promotion from "./promotion/zh_cn.yml";
import newsletter from "./newsletter/zh_cn.yml";
import activity from "./activity/zh_cn.yml";

export const labelZhCn: any = {
  common: common["zh_cn"]["adminLabelCommon"],
  form: form["zh_cn"]["adminLabelForm"],
  adminUser: adminUser["zh_cn"]["adminLabelAdminUser"],
  hotel: hotel["zh_cn"]["adminLabelHotel"],
  hotelRoom: hotelRoom["zh_cn"]["adminLabelHotelRoom"],
  hotelPlan: hotelPlan["zh_cn"]["adminLabelHotelPlan"],
  hotelCancelPolicy: hotelCancelPolicy["zh_cn"]["adminLabelHotelCancelPolicy"],
  hotelChildrenSetting:
    hotelChildrenSetting["zh_cn"]["adminLabelChildrenSetting"],
  hotelQuestion: hotelQuestion["zh_cn"]["adminLabelHotelQuestion"],
  hotelOption: hotelOption["zh_cn"]["adminLabelHotelOption"],
  hotelFilter: hotelFilter["zh_cn"]["adminLabelHotelFilter"],
  hotelMail: hotelMail["zh_cn"]["adminLabelHotelMail"],
  hotelWaitingList: hotelWaitingList["zh_cn"]["adminLabelHotelWaitingList"],
  hotelInventory: hotelInventory["zh_cn"]["adminLabelHotelInventory"],
  hotelPrice: hotelPrice["zh_cn"]["adminLabelHotelPrice"],
  hotelScript: hotelScript["zh_cn"]["adminLabelHotelScript"],
  hotelCheckIn: hotelCheckIn["zh_cn"]["adminLabelHotelCheckIn"],
  hotelCheckInQuestion:
    hotelCheckInQuestion["zh_cn"]["adminLabelHotelCheckInQuestion"],
  hotelPushMessageGroup:
    hotelPushMessageGroup["zh_cn"]["adminLabelHotelPushMessageGroup"],
  hotelCalendar: hotelCalendar["zh_cn"]["adminLabelHotelCalendar"],
  booking: booking["zh_cn"]["adminLabelBooking"],
  company: company["zh_cn"]["adminLabelCompany"],
  companyInvoice: companyInvoice["zh_cn"]["adminLabelCompanyInvoice"],
  companyPayment: companyPayment["zh_cn"]["adminLabelCompanyPayment"],
  promotion: promotion["zh_cn"]["adminLabelPromotion"],
  newsletter: newsletter["zh_cn"]["adminLabelNewsletter"],
  activity: activity["zh_cn"]["adminLabelActivity"],
};
